import { supabase } from '../supabase';

/**
 * How many sessions a week a program calls for: its days divided by its weeks.
 * Weeks with no days are left out of both numbers, so a half-built week does not
 * drag the target down. Null when there is no week with a day in it.
 *
 * `week`: only that week (This Week). `upToWeek`: only the weeks the client has reached,
 * so a day added to a later week ("Add a day", migration 087) does not raise the target
 * before the client gets there (Codex's review 032, R4).
 */
export const weeklySessionTarget = (weeks, { week = null, upToWeek = null } = {}) => {
  const withDays = (weeks || []).filter(w => (w.program_days || []).length > 0
    && (week == null || w.week_number === week)
    && (upToWeek == null || w.week_number == null || w.week_number <= upToWeek));
  if (withDays.length === 0) return null;
  const totalDays = withDays.reduce((n, w) => n + w.program_days.length, 0);
  return totalDays / withDays.length;
};

/**
 * Reads the weeks and days themselves, not the `programs` row above them. A coach
 * may read the content of a client's program without being able to read its
 * header row (migration 059 opened the content; the header waited for 064), and
 * asking for the header with .single() answered HTTP 406 for them, so the target
 * went missing without a trace. Throws if the lookup fails.
 */
export const loadWeeklySessionTarget = async (programId, which = {}) => {
  const { data, error } = await supabase
    .from('program_weeks')
    .select('id, week_number, program_days ( id )')
    .eq('program_id', programId);
  if (error) throw error;
  return weeklySessionTarget(data, which);
};
